/**
 * Created by alex.shmaltsuev on 2016-04-06.
 */
// import Constants from  '../constants/auth';
// import { Record } from 'immutable';
// import {createAction} from 'redux-actions';
import {axiosInstance} from '../utils/helpers';
import C_USER from  '../constants/user';
import {getObjByKey} from '../utils/helpers';
import {setFetchingCount} from './app';



// export function initUserSettings() {
//     return function (dispatch, state) {
//         axiosInstance.get('/api/v1/userSettings?ssp=true')
//             .then((response)=> {
//                 var timeArrayHelper = response.data.dateFormat.split(/ (.+)?/);
//                 response.data.dateFormat = timeArrayHelper[0].toLowerCase().replace('yyyy', 'yy');
//                 response.data.dateFormat += ' ' + timeArrayHelper[1].replace('a', 'TT');
//                 dispatch({
//                     type: Constants.INIT_USER_SETTINGS,
//                     data: Record(response.data)
//                 });
//             });
//     }
// }

export function getUserDetails() {
    return (dispatch) => {
        dispatch(setFetchingCount(true));
        axiosInstance.get('/api/v1/users/me')
            .then((response) => {
                let isGuest = response.data.isGuest;
                dispatch({
                    type: C_USER.SET_IS_GUEST,
                    payload: isGuest
                });

                let calculatedUserName = getObjByKey(response.data.info, 'calculated_user_name');
                dispatch({
                    type: C_USER.SET_USER_CALCULATED_NAME,
                    payload: calculatedUserName.value
                });

                let userName = response.data.name;
                dispatch({
                    type: C_USER.SET_USER_NAME,
                    payload: userName
                });

                let userPhoto = getObjByKey(response.data.info, 'my_photo_url');
                userPhoto = userPhoto.value;
                if (!userPhoto) {
                    userPhoto = '';
                }
                dispatch({
                    type: C_USER.SET_USER_PHOTO,
                    payload: userPhoto
                });

                let timeZone = getObjByKey(response.data.info, 'timezone');
                if (timeZone) {
                    dispatch({
                                 type: C_USER.SET_TIME_ZONE,
                                 payload: timeZone.value
                             });
                }

                let locale = getObjByKey(response.data.info, 'locale');
                if (locale) {
                    dispatch({
                                 type: C_USER.SET_LOCALE,
                                 payload: locale.value
                             });
                }

                let firstDayOfWeek = getObjByKey(response.data.info, 'firstDayOfWeek');
                if (firstDayOfWeek) {
                    dispatch({
                                 type: C_USER.SET_FIRST_DAY_OF_WEEK,
                                 payload: firstDayOfWeek.value
                             });
                }

                let inputDate = getObjByKey(response.data.info, 'inputDate');
                if (inputDate) {
                    dispatch({
                                 type: C_USER.SET_INPUT_DATE,
                                 payload: inputDate.value
                             });
                }
            })
            .finally(() => {
                dispatch(setFetchingCount(false));
            });
    }
}


export function setUserPhotoUpdated(isUpdated){
    return {
        type: C_USER.SET_USER_PHOTO_UPDATED,
        payload: isUpdated
    };
}


// WEBPACK FOOTER //
// ./actions/user.js